import {baseNewImagesPath} from "../../assets";

export const applianceThumbnail    = `${baseNewImagesPath}images/kv-icons/kv-filter-icons-stove.svg`;
export const cabinetThumbnail    = `${baseNewImagesPath}images/kv-icons/top_cabinet.svg`;
export const centerIslandThumbnail    = `${baseNewImagesPath}images/kv-icons/center_island_countertop.svg`;
export const countertopGroupThumbnail    = `${baseNewImagesPath}images/kv-icons/vanity-countertop.svg`;
export const wallsThumbnail    = `${baseNewImagesPath}images/bv_icons_new/Icons_Wall.svg`;
export const floorThumbnail    = `${baseNewImagesPath}images/bv_icons_new/Icons_Floor.svg`;

export const largeLayoutShadow = `${baseNewImagesPath}images/bv-assets/KV-All-Global-Shadow-Placeholder_L_1620x1080.png`;
export const SmallLayoutShadow = `${baseNewImagesPath}images/bv-assets/KV-All-Global-Shadow-Placeholder_S_1620x1080.png`;

/*layouts*/
export const LayoutThumbnails = {
  Small: `${baseNewImagesPath}images/kv-layout-thumbnails/S.png`,
  SmallWithPopout: `${baseNewImagesPath}images/kv-layout-thumbnails/SP.png`,
  SmallWithPeninsula: `${baseNewImagesPath}images/kv-layout-thumbnails/SN.png`,
  SmallWithIsland: `${baseNewImagesPath}images/kv-layout-thumbnails/SI.png`,
  SmallWithPopoutWithPeninsula: `${baseNewImagesPath}images/kv-layout-thumbnails/SPN.png`,
  SmallWithPopoutWithIsland: `${baseNewImagesPath}images/kv-layout-thumbnails/SPI.png`,
  SmallWithPeninsulaWithIsland: `${baseNewImagesPath}images/kv-layout-thumbnails/SNI.png`,
  SmallWithPopoutWithPeninsulaWithIsland: `${baseNewImagesPath}images/kv-layout-thumbnails/SPNI.png`,
  LShape: `${baseNewImagesPath}images/kv-layout-thumbnails/L.png`,
  LShapeWithPeninsula: `${baseNewImagesPath}images/kv-layout-thumbnails/LN.png`,
  LShapeWithIsland: `${baseNewImagesPath}images/kv-layout-thumbnails/LI.png`,
  LShapeWithPeninsulaWithIsland: `${baseNewImagesPath}images/kv-layout-thumbnails/LNI.png`,
};
